export default __webpack_public_path__ + "static/media/Importador3BudgetForecast.c38f505c.pdf";